import { Injectable } from '@angular/core';
import { INetworkError } from './shared';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  addClasses(classList: DOMTokenList, classes: string): void {
    if (classes) {
      classList.add(classes);
    }
  }

  removeClasses(classList: DOMTokenList, classes: string): void {
    if (classes) {
      classList.remove(classes);
    }
  }

  getTextFromNetworkError(err: INetworkError): string {
    // Show message from backend when available
    if (err.error?.messages?.length) {
      return err.error.messages.join('; ');
    }
    // Fallback to error description from OAuth error
    const oauthErrorDescription: string = (err.error as any)?.error_description;
    if (typeof oauthErrorDescription === 'string') {
      return oauthErrorDescription;
    }
    const oauthError: string = (err.error as any)?.error;
    if (typeof oauthError === 'string') {
      return oauthError;
    }
    // Fallback show status and message
    return `${err.status}: ${err.message || 'An error occurred'}`;
  }
}
